export default __webpack_public_path__ + "static/media/men.6a4c58de.png";